import React from 'react'

import Row from '@amzn/meridian/row'
import Text from '@amzn/meridian/text'

import { navBarConfig } from '@utils/ui-config'
import { getToolNameToDetailMap } from '@services/ToolMenuConfigService'

import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'

interface IToolNameProps {
    toolName?: string
}

/**
 * Renders the tool name with Meridian style text.
 *
 * Takes whatever width the masthead has left over -- NavBarInfo marks this the filling
 * child of its row -- so the icons beside it end up flush with the right edge. `minWidth`
 * lets it shrink below the name's own min-content width, which is what lets a long name
 * truncate rather than push those icons off screen.
 *
 * Usage:
 * <ToolName toolName="sampleTool" />
 *
 * @param {string} toolName Tool name to be rendered as text.
 * @returns {React.ReactElement}
 */
const ToolName = ({
    toolName,
}: Readonly<IToolNameProps>): React.ReactElement => {
    const [bundle] = useBundle(BUNDLE_NAME)

    return (
        <Row minWidth={0}>
            <Text truncate={true} data-atb-id={'navbar-tool-name-text'} type={navBarConfig.TOOL_NAME_TEXT_SIZE}>
                {
                    t(
                        bundle,
                        getToolNameToDetailMap().get(toolName)?.translateID,
                    ) || toolName || t(bundle, 'migrated-ihm-seaward-welcome-title') || navBarConfig.TOOL_NAME_DEFAULT_TEXT
                }
            </Text>
        </Row>
    )
}

export default ToolName
